<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			headline: string;
			text: string;
			asset: ISbStoryData[];
		}>['content'];
		index: number;
	}

	let { content, index }: Props = $props();
</script>

<div use:editable={content} class="grid grid-cols-1 overflow-hidden rounded-[20px] lg:rounded-3xl">
	<div class="col-span-full row-start-1 aspect-2/3 lg:aspect-3/2">
		<Blok content={content.asset[0]} threshold={0.8} />
	</div>

	<div class="col-span-full row-start-1 flex flex-col justify-between">
		<div
			class="z-10 p-5 font-serif text-[64px]/[100%] tracking-[-1.28px] text-white lg:p-8 lg:text-[96px]/[100%] lg:tracking-[-1.92px]"
		>
			{index + 1}
		</div>
		<div class="text-container z-10 w-full text-pretty p-6 text-white lg:p-8">
			<div class="lg:max-w-[75%]">
				<p
					class="text-[36px]/[112%] font-semibold tracking-[-.36px] lg:text-[48px]/[120%] lg:tracking-[-.48px]"
				>
					{content.headline}
				</p>
				<p
					class="mt-3 text-[20px]/[140%] tracking-[-.2px] lg:mt-2 lg:text-[24px]/[140%] lg:tracking-[-.24px]"
				>
					{content.text}
				</p>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	div.text-container {
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
	}
</style>
